import { DDSInput, DDSTypography } from 'den-design-system'
import React, { useEffect, useState } from 'react'

import { IoSearch } from 'react-icons/io5'
import { SearchProps } from './Search.types'
import pallete from '../../../global/newPallete'

const Search: React.FC<SearchProps> = ({
  id,
  name,
  suffixIcon,
  label,
  errorMessage,
  value,
  placeholder = '',
  autoComplete = 'on',
  disabled = false,
  onBlur,
  onFocus,
  onChange,
  width,
  onPressEnter
}) => {
  const [animatedPlaceholder, setAnimatedPlaceholder] = useState('')

  useEffect(() => {
    if (!placeholder) return
    let i = 0
    setAnimatedPlaceholder('')

    const interval = setInterval(() => {
      if (i < placeholder.length) {
        const nextChar = placeholder.charAt(i)
        setAnimatedPlaceholder((prev) => prev + nextChar)
        i++
      } else {
        clearInterval(interval)
      }
    }, 100)

    return () => clearInterval(interval)
  }, [placeholder])

  const handleChange = (event: any) => {
    let newValue = event.target.value
    newValue = newValue.replace(/^\s+/, '')
    newValue = newValue.replace(/\s+/g, ' ')
    onChange?.({ ...event, target: { ...event.target, value: newValue } })
  }
  return (
    <div className='override-input-search'>
      <DDSInput
        id={id}
        name={name}
        width={width}
        variant='plain'
        type='text'
        shape='roundedRectangle'
        autoComplete={autoComplete}
        prefixIcon={<IoSearch size={16} color={pallete.colors.textDark7} />}
        suffixIcon={suffixIcon}
        className='overriding-search truncate break-words'
        label={label}
        errorMessage={errorMessage}
        value={value}
        placeholder={animatedPlaceholder}
        disabled={disabled}
        onPressEnter={onPressEnter}
        onBlur={onBlur}
        onFocus={onFocus}
        onChange={handleChange}
        validateInput={false}
        style={{
          height: '28px',
          borderColor: pallete.colors.stroke2
        }}
      />
      {errorMessage && (
        <DDSTypography.Paragraph
          size='caption'
          variant='regular'
          color={pallete.colors.warningRed2}
        >
          {errorMessage}
        </DDSTypography.Paragraph>
      )}
    </div>
  )
}

export default Search
